import { ReactElement, useMemo } from 'react';
import type { ColumnsType } from 'antd/es/table';
import { Table as AntTable } from 'antd';
import DetailButton from './DetailButton';
import { Advisor } from '@minutes-system/backend/src/api/advisors/schema';

interface Props {
  data: Advisor[];
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}
const Table = ({ data, page, pageSize, total, onPageChange }: Props): ReactElement => {
  const columns: ColumnsType<Advisor> = useMemo(
    () => [
      { title: 'ID', dataIndex: 'id', key: 'id', width: 120 },
      { title: '氏名', dataIndex: 'name', key: 'name', width: 240, ellipsis: true },
      {
        title: '電話番号',
        dataIndex: 'phone',
        key: 'phone',
        width: 160,
      },
      {
        title: '操作',
        key: 'action',
        width: 120,
        render: (_, record) => <DetailButton id={record.id} />,
      },
    ],
    []
  );

  return (
    <AntTable<Advisor>
      rowKey='id'
      dataSource={data}
      columns={columns}
      tableLayout='auto'
      pagination={{
        current: page,
        pageSize,
        total,
        showSizeChanger: false,
        showTotal: (total, range) => `${String(range[0])}-${String(range[1])} of ${String(total)}`,
        onChange: p => {
          onPageChange(p);
        },
      }}
    />
  );
};

export default Table;
